const IconDownArrow = () => {
  return <polygon points="6,9 12,15 18,9" fill="currentColor" />;
};

export default IconDownArrow;
